export const originalFetch = window.fetch;

window.fetch = (url, config) =>
  originalFetch(url, { ...config, headers: { ...config?.headers, "X-Auth-User-Token": "" } });

export default function fetchInterceptor(userToken: string) {
  window.fetch = (url, config) => {
    return originalFetch(url, { ...config, headers: { ...config?.headers, "X-Auth-User-Token": userToken } });
  };
}
